import { Link } from '@tanstack/react-router';
import { EmptyState, ErrorState } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t('common.states.notFoundTitle')}
      description={t('common.states.notFoundDescription')}
      action={
        <Link to="/" className="btn sm">
          {t('shell.nav.entries.dashboard')}
        </Link>
      }
    />
  );
}

export function AccessDeniedPage() {
  const { t } = useTranslation();
  return (
    <ErrorState
      title={t('common.states.deniedTitle')}
      description={t('common.states.deniedDescription')}
      action={
        <Link to="/" className="btn sm">
          {t('shell.nav.entries.dashboard')}
        </Link>
      }
    />
  );
}
